module.exports = __webpack_public_path__ + "img/super_interest_info.a958a976.png";